import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopGeidea = dynamic(() => import("../../components/software-partners/GeideaPayments/DesktopGeidea"), {
    loading: () => <Loading />,
});

const MobileGeidea = dynamic(() => import("../../components/software-partners/GeideaPayments/MobileGeidea"), {
    loading: () => <Loading />,
});

const GeideaPayments = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with Geidea Payments Integration | Seamless Payment Solutions</title>
                <meta name="description" content="Integrate QueueBuster POS with Geidea Payments for fast and secure transactions. Simplify payment processes and enhance your business operations effortlessly." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/geidea-payments" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/geidea-payments" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + Geidea Payments: Simplify Your Payment Experience" />
                <meta property="og:description" content="Streamline your payment operations with QueueBuster POS and Geidea Payments integration. Enjoy secure, efficient, and hassle-free transactions for your business." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/Group+1171276125.png" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/geidea-payments" />
            </Head>
            {mobileView ? <MobileGeidea /> : <DesktopGeidea />}
        </>
    )
}

export default GeideaPayments;




 



 